<template>
  <tr :class="[{'danger': hasErrors(pInputPrefix)}]">
    <td class="minWidthCell"><button class="btn btn-default" @click.prevent="removeOption" :disabled="deleteButtonDisabled"><i class="fa-light fa-times"></i></button></td>
    <td :class="{'has-error': hasFieldErrors(pInputPrefix + '.name')}">
      <input type="hidden"
             id="tag_value_id"
             :name="pInputPrefix + '.id'"
             v-model="data.id"
             class="form-control"/>
      <input type="text"
             id="tag_value_name"
             :name="pInputPrefix + '.name'"
             v-model="data.name"
             class="form-control"/>
      <span v-for="(error, index) in getFieldErrors(pInputPrefix + '.name')"
            :key="pInputPrefix + '_name_error_' + index" class="help-block">{{ error }}</span>
    </td>
  </tr>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";

export default {
  name: "TagSaveFormOption",
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pData: Object,
    pInputPrefix: String,
    pRemovable: Boolean
  },
  data: function () {
    return {
      data: this.pData,
      errorList: []
    }
  },
  methods: {
    removeOption: function() {
      this.$emit('remove-option', this.data);
    }
  },
  computed: {
    deleteButtonDisabled: function() {
      return !this.pRemovable;
    }
  }
}
</script>

<style scoped>

</style>